export default __webpack_public_path__ + "static/media/fruitsVegBasket.25a3a886.jpg";